<script setup>
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useClientStore } from "@/store/client";
import { useAuthStore } from "@/store/auth";

definePageMeta({
  middleware: ["nouvelle-fidelite", "forbidden-pro"]
});

const router = useRouter();

const { trackPage } = useTrackingPage();

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.accueilFidelite);
});

const { isLogged } = storeToRefs(useAuthStore());
const { fetchDefisFidelite, fetchFidelities } = useClientStore();
const { fidelitesWithExpires, client, fidelites } = storeToRefs(
  useClientStore()
);

if (isLogged.value) {
  await useAsyncData(() => fetchFidelities());
}

await fetchDefisFidelite(
  fidelites.value.length === 1
    ? fidelites.value[0].attributes.type_carte
    : undefined
);
const component = computed(() => {
  return loadPageWithLoader(() =>
    import("@/components/pages/accueil-fidelite")
  );
});

watch(
  () => client.value,
  () => {
    return router.go();
  }
);
</script>

<template>
  <component
    :is="component"
    :cartes="fidelitesWithExpires"
  />
</template> 
